import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getByJournalId: {
        method: 'GET',
        url: `${BASE_PATH_API}/approvalRequests?journalIds=:journalId`
    },
    getPaymentApprovals: {
        method: 'GET',
        url: `${BASE_PATH_API}/approvalRequests/bill/:billId`
    },
    getApprovalStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/approvalRequests/:journalId/status/`
    },
    create: {
        method: 'POST',
        url: `${BASE_PATH_API}/approvalRequests`
    },
    update: {
        method: 'PUT',
        url: `${BASE_PATH_API}/approvalRequests/:journalId`
    },
    updateEftRequest: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/approvalRequests/journalRequest`
    },
    cancelEftRequest: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/approvalRequests/journalRequest/:journalRequestId/cancel`
    }
};

export function ApprovalRequestsApi() {
    return createActions(actions);
}
